import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {path: '/user',name:'user', component: resolve => require(['@/components/User'], resolve)},
    {path: '/role',name:'role', component: resolve => require(['@/components/Role'], resolve)},
    {path: '/log',name:'log', component: resolve => require(['@/components/Log'], resolve)},
    {path: '/login',name:'login', component: resolve => require(['@/components/login'], resolve)},
    {path: '/homepage',name:'homepage', component: resolve => require(['@/components/HomePage'], resolve)},
    {path: '/databrowser',name:'databrowser', component: resolve => require(['@/components/DataBrowser'], resolve)},
    {path: '/gene',name:'gene', component: resolve => require(['@/components/Gene'], resolve)},
    {path: '/pathway',name:'pathway', component: resolve => require(['@/components/Pathway'], resolve)},
    {path: '/infiltrates',name:'infiltrates', component: resolve => require(['@/components/Infiltrates'], resolve)},
    {path: '/datadownload',name:'datadownload', component: resolve => require(['@/components/DataDownload'], resolve)},
    {path: '/documention',name:'documention', component: resolve => require(['@/components/Documention'], resolve)},


    // {path: '/exploregene',name:'exploregene', component: resolve => require(['@/components/ExploreGene'], resolve)},
    // {path: '/exploredata',name:'exploredata', component: resolve => require(['@/components/ExploreData'], resolve)},
    // {path: '/uploaddata',name:'uploaddata', component: resolve => require(['@/components/UploadData'], resolve)},
    {path: '/internaldata',name:'internaldata', component: resolve => require(['@/components/InternalData'], resolve)},
    {path: '/systemtools',name:'systemtools', component: resolve => require(['@/components/SystemTools'], resolve)},
    {path: '/systeminfo',name:'systeminfo', component: resolve => require(['@/components/SystemInfo'], resolve)},
    {path: '/submitdata',name:'submitdata', component: resolve => require(['@/components/SubmitData'], resolve)},
    {path: '/systemconfig',name:'systemconfig', component: resolve => require(['@/components/SystemConfig'], resolve),
      children: [
        {path: 'userconfig',name:'userconfig',components:{systemMenu:resolve => require(['@/components/Userconfig'], resolve) }},
        {path: 'roleconfig',name:'roleconfig',components:{systemMenu:resolve => require(['@/components/Roleconfig'], resolve) }},
        {path: 'departmentconfig',name:'departmentconfig',components:{systemMenu:resolve => require(['@/components/DepartmentConfig'], resolve) }},
        {path: 'menusconfig',name:'menusconfig',components:{systemMenu:resolve => require(['@/components/MenusConfig'], resolve) }},
        {path: 'logconfig',name:'logconfig',components:{systemMenu:resolve => require(['@/components/LogConfig'], resolve) }},
      ]
    },
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js